import PropTypes from 'prop-types'
import React from 'react'
import L from 'leaflet'
import pointer from 'assets/img/pointer-maps.png'
import 'leaflet/dist/leaflet.css'
import { MapContainer, Marker, Popup, TileLayer, useMap } from 'react-leaflet'

export default function CustomMarker({ position, children }) {
  const map = useMap()

  const customIcon = L.icon({
    iconUrl: pointer,
    // iconSize: [50, 70],
    // iconAnchor: [25, 70],
    iconSize: [50, 50],
    iconAnchor: [25, 50]
  })

  return (
    <Marker position={position} icon={customIcon}>
      {children}
    </Marker>
  )
}

CustomMarker.propTypes = {
  position: PropTypes.any,
  children: PropTypes.any
}
